export abstract class TextHelper {

    public static formatTextWrap(text: string, maxLineLength: number): string {
        const words = text.replace(/[\r\n]+/g, ' ').split(' ');
        let lineLength = 0;
                
        // use functional reduce, instead of for loop 
        return words.reduce((result, word) => {
          if (lineLength + word.length >= maxLineLength) {
            lineLength = word.length;
            
            return result + `\n${word}`; // don't add spaces upfront
          } else {
            lineLength += word.length + (result ? 1 : 0);
            return result ? result + ` ${word}` : `${word}`; // add space only when needed
          }
        }, '');
      }

      //a function that accepts a string, a maxLineLength as a parameter, and can wrap a string into an array of strings
        
      public static wrapStringIntoArray(str: string, maxLineLength: number): string[] {
        if (!str) return [];
        
        const words = str.split(' ');
        const lines = [];
        let currentLine = words[0];
      
        for (let i = 1; i < words.length; i++) {
          const word = words[i];
          if (currentLine.length + word.length + 1 > maxLineLength) {
            lines.push(currentLine);
            currentLine = word;
          } else {
            currentLine += ' ' + word;
          }
        }
      
        lines.push(currentLine);
        return lines;
      }
 
      //1,2,4,7 -> '-es'
      //3,8 -> '-as'
      //5 -> '-ös'
      //6 -> '-os'
      public static getNumberHunSuffix(num: number): string {
        if (num === 1 || num === 2 || num === 4 || num === 7 || num === 9) return '-es';
        if (num === 3 || num === 8) return '-as';
        if (num === 5) return '-ös';
        if (num === 6) return '-os';
        return '';
      }
}